import styled, { css } from 'styled-components';
import { isGlobetrotter } from '../../utils/theming.js';

// @ts-nocheck
var SrOnly = styled.span.withConfig({
  displayName: "Stepperstyle__SrOnly",
  componentId: "sc-qz54e9-0"
})(["position:absolute;top:auto;width:1px;height:1px;overflow:hidden;opacity:0;"]);
var Stepper = styled.div.withConfig({
  displayName: "Stepperstyle__Stepper",
  componentId: "sc-qz54e9-1"
})(["align-items:center;display:flex;"]);
var Value = styled.div.withConfig({
  displayName: "Stepperstyle__Value",
  componentId: "sc-qz54e9-2"
})(["color:var(--color-teal-800);display:flex;font-family:var(--font-family-headline-light);font-size:2.4rem;justify-content:center;width:4.4rem;", ""], isGlobetrotter(css(["color:var(--color-grey-800);font-family:var(--font-family-body);font-size:1.8rem;width:5.1rem;"])));
var Description = styled.div.withConfig({
  displayName: "Stepperstyle__Description",
  componentId: "sc-qz54e9-3"
})(["display:flex;flex-direction:column;flex-grow:1;"]);
var Title = styled.div.withConfig({
  displayName: "Stepperstyle__Title",
  componentId: "sc-qz54e9-4"
})(["font-family:var(--font-family-headline);font-size:1.6rem;line-height:2rem;text-transform:capitalize;"]);
var Subtitle = styled.div.withConfig({
  displayName: "Stepperstyle__Subtitle",
  componentId: "sc-qz54e9-5"
})(["font-family:var(--font-family-body);color:var(--color-grey-600);font-size:1.2rem;line-height:1.6rem;text-transform:uppercase;", ""], isGlobetrotter(css(["text-transform:unset;"])));
var ButtonContainer = styled.div.withConfig({
  displayName: "Stepperstyle__ButtonContainer",
  componentId: "sc-qz54e9-6"
})(["align-items:center;display:flex;"]);
var Button = styled.button.withConfig({
  displayName: "Stepperstyle__Button",
  componentId: "sc-qz54e9-7"
})(["display:flex;svg{height:2.8rem;width:2.8rem;color:var(--color-cta-button-primary);", "}", " ", ""], function (props) {
  return props.$disabled && css(["color:var(--color-text-disabled);"]);
}, isGlobetrotter(css(["padding:10px;border:solid 1.5px var(--color-cta-button-primary);&:hover{border-color:var(--color-cta-button-primary-hover);color:var(--color-cta-button-primary-hover);}svg{height:1.8rem;width:1.8rem;}"])), function (props) {
  return props.$disabled && css(["color:var(--color-text-disabled);color:var(--color-text-disabled);border-color:var(--color-border-disabled);pointer-events:none;"]);
});

export { Button, ButtonContainer, Description, SrOnly, Stepper, Subtitle, Title, Value };
//# sourceMappingURL=Stepper.style.js.map
